export enum ECardTypes {
  Debate = 'debate',
  Challenge = 'challenge',
}

export type TCardType = ECardTypes.Debate | ECardTypes.Challenge;

export type TAlertDialog = {
  title: string;
  text: string;
  сonsentText: string;
  сonsentCallback: () => void;
  dissentText: string;
  dissentCallback?: () => void;
};

export type TMenuOption = {
  name: string;
  dialogInfo: TAlertDialog;
};

export enum EUserRole {
  Initiator = 'initiator',
  Opponent = 'opponent',
  RegularUser = 'regularUser',
}

export type TUserRole = EUserRole.Initiator | EUserRole.Opponent | EUserRole.RegularUser;

export type TCardMainButtonInfo = {
  text: string;
  onClick: () => void;
};

export enum EAvatarTypes {
  Header = 'header',
  Profile = 'profile',
  SmallCard = 'smallCard',
  FullCard = 'fullCard',
  MobileMenu = 'mobileMenu',
  CardFeatures = 'cardFeatures',
}

export type TAvatarType =
  | EAvatarTypes.Header
  | EAvatarTypes.Profile
  | EAvatarTypes.SmallCard
  | EAvatarTypes.FullCard
  | EAvatarTypes.MobileMenu
  | EAvatarTypes.CardFeatures;

export type TAvatarStyle = number | Record<string, number>;

export type TAvatarStyles = {
  [M in TAvatarType]: {
    stack: any;
    typography: any;
  };
};
